import { useEffect, useState } from "react";
import { Modal, Alert } from "react-bootstrap";
import { organizerUpdateGiftApi } from "../../api/api";
import { isFullName } from "./giftHelpers";

// Only the guest name is editable. Email, note and expiry are intentionally not
// exposed here: the QR already travelled to the recipient, so changing the
// delivery data after the fact would silently desync the invitation from the
// email the guest is holding.
export default function GiftEditModal({ show, order, onHide, onSaved }) {
  const initialName = order?.giftLabel || order?.recipientName || "";
  const [recipientName, setRecipientName] = useState(initialName);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setRecipientName(order?.giftLabel || order?.recipientName || "");
    setError("");
  }, [order]);

  const handleSubmit = async (event) => {
    event?.preventDefault?.();
    setError("");

    if (!isFullName(recipientName)) {
      setError("Ingresá nombre y apellido.");
      return;
    }

    // Nothing changed: close without touching the server.
    if (recipientName.trim() === initialName.trim()) {
      onHide?.();
      return;
    }

    setSubmitting(true);
    try {
      await organizerUpdateGiftApi(order.orderId, { recipientName: recipientName.trim() });
      onSaved?.();
      onHide?.();
    } catch (err) {
      setError(
        err?.response?.status === 409
          ? "La invitación ya fue utilizada y no se puede modificar."
          : "No se pudo guardar la invitación. Intentá de nuevo."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="gifts-especiales">
      <Modal.Header closeButton>
        <Modal.Title>Editar invitación</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}

          <div className="zoco-field">
            <label className="zoco-label" htmlFor="gift-edit-name">Nombre y apellido</label>
            <div className="zoco-control">
              <input
                id="gift-edit-name"
                type="text"
                placeholder="Ej: Juan Perez"
                value={recipientName}
                onChange={(event) => setRecipientName(event.target.value)}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="zoco-ticket-btn light"
            onClick={onHide}
            disabled={submitting}
          >
            Cancelar
          </button>
          <button type="submit" className="zoco-ticket-btn dark" disabled={submitting}>
            {submitting ? "Guardando…" : "Guardar"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
